module.exports = __webpack_public_path__ + "8eced1685e1f60f9dafb8b9f3bf772ce.png";